module.exports = __webpack_public_path__ + "img/spa.26b27e7e.png";